// extracted by mini-css-extract-plugin
export default {"Container":"ResponsiveSlider_Container__EIKoD","Members":"ResponsiveSlider_Members__DOWph","Slider":"ResponsiveSlider_Slider__gHzwd","Dots":"ResponsiveSlider_Dots__vy9MV"};